import React, { useEffect, useState } from 'react';
import SideBar from '../../Layouts/SideBar';
import { useParams } from 'react-router-dom';
import Instance from '../../Services/Instance';
import config from "../../Services/config";

function ShowFaq() {
    const [faq, setFaq] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { id } = useParams();

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await Instance.get(`${config.api_url}/faq/items/${id}`);
           
            
            setFaq(result.data.data);
            setLoading(false);
        } catch (error) {
            //console.log("Erreur lors de la récupération de cette FAQ", error);
            setError(error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);
    
    if (loading) {
        return (
            <div>
                <SideBar />
                <div className='show-elements-details'>
                    <p>Chargement...</p>
                </div>
            </div>
        );
    }

    if (error || !faq) {
        return (
            <div>
                <SideBar />
                <div className='show-elements-details'>
                    <p>FAQ non trouvée ou erreur lors du chargement</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            <SideBar />
            <div className='show-elements-details'>
                <p>Question : <span>{faq.title}</span></p>
                <p>Slug : <span>{faq.slug}</span></p>
                <p>Catégorie : <span>{faq.category?.name || 'Non définie'}</span></p>
                <p>Réponse : <span>{faq.answer}</span></p>
                <p>Mots-clés : <span>{faq.keywords?.join(', ') || 'Aucun'}</span></p>
                <p>Statut : <span>{faq.isPublished ? 'Publié' : 'Non publié'}</span></p>
                <p>Vues : <span>{faq.views || 0}</span></p>
                <p>Créé le : <span>{new Date(faq.createdAt).toLocaleDateString('fr-FR')}</span></p>
            </div>
        </div>
    );
}

export default ShowFaq;